import * as Mocha from 'mocha';
import { MochaUiEsmOptions } from './mochaUiEsmOptions.js';
import { getTestsFromEsmModule } from './getTestsFromEsmModule.js';

/**
 * Represents the Mocha interfaces record.
 */
export type MochaInterfaces = Record<string, (suite: Mocha.Suite) => void>;

/**
 * Registers the Mocha UI for ESM.
 * 
 * This adds an `esm` property to the provided Mocha interfaces. When a suite is configured
 * with the `esm` UI, it will listen for the `modules` event and parse test definitions
 * from the provided ESM modules.
 *
 * @param mochaInterfaces - The Mocha interfaces to register the UI with.
 * @param options - Optional configuration for the ESM test runner.
 */
export function registerMochaUiEsm(
  mochaInterfaces: MochaInterfaces,
  options?: Partial<MochaUiEsmOptions>
): void {
  mochaInterfaces.esm = function (suite: Mocha.Suite) {
    suite.on('modules', (modules: any) =>
      getTestsFromEsmModule(suite, new MochaUiEsmOptions(options), modules)
    );
  };
}

export default registerMochaUiEsm;
export * from 'esm-test-parser';
export { MochaUiEsmOptions };
